export default "__VITE_ASSET__PAIeTsKG__"